import React from 'react';
import {Select} from 'antd';

import {FormFieldInputWrapperClasses, FormFieldWrapperClasses} from '../';
import {trb} from '../../../Utilities';

const Option = Select.Option;

export class SelectFormField extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            active: !this.props.input.value && this.props.input.value !== 0
            && !this.props.defaultValue && this.props.defaultValue !== 0 ? true : false,
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if ((this.props.input.value && this.props.input.value !== prevProps.input.value)
        || (this.props.defaultValue  && this.props.defaultValue !== prevProps.defaultValue)) this.setState({
            active: false,
        });
    }

    onBlur = (e) => {
        if (!this.props.input.value && this.props.input.value !== 0) this.setState({
            active: true
        });
        if (e) this.props.input.onBlur(e);
    }

    onSelect = () => {
        this.setState({
            active: false
        });
    }

    onValueChange = (value) => {
        this.props.input.onChange(value);
    }

    onClear = () => {
        this.setState({
            active: true,
        });
    }

    render = () => {
        const {
            title,
            allowClear,
            titleWithoutTranslate,
            className,
            classNameField,
            classNameTitle,
            classNameError,
            inline,
            size,
            placeholder,
            disabled,
            options,
            optionsLabel,
            optionsDisabled,
            optionsValue,
            translate,
            meta,
            small,
            optionsColor,
            optionsLabelImg,
              getPopupContainer
        } = this.props,
        {active} = this.state;

        const checkOption = (value, input) => {
            if (!options) {
                return null;
            }

            const optionValue = options.find(e => e[optionsValue] === value);

            if (optionValue) {
                return value;
            } else {
                input.onChange(undefined);
            }
        };

        return <div className={FormFieldWrapperClasses(className, inline, disabled, active, small)}>
            {title && <div className={
                classNameTitle
                ? 'form-field-title form-field-title-select' + classNameTitle
                : inline
                    ? (className && className.indexOf('col-12') === -1) || (className && className.indexOf('col-12') !== -1 && className.indexOf('col-md-') !== -1)
                        ? 'form-field-title form-field-title-select col-12 col-md-5 text-left text-md-right pb-2 pb-md-0 pr-md-0'
                        : 'form-field-title form-field-title-select col-12 col-md-3 text-left text-md-right pb-2 pb-md-0'
                    : 'form-field-title form-field-title-select col-12'
            }>{titleWithoutTranslate ? title : trb(title)}</div>}
            <div className={
                classNameField
                    ? 'form-field-item ' + classNameField
                    : FormFieldInputWrapperClasses(meta.error, meta.submitError, meta.touched, inline, className)}>
                <Select
                    allowClear={allowClear}
                    placeholder={trb(placeholder)}
                    disabled={disabled}
                    name={this.props.input.name}
                    value={checkOption(this.props.input.value, this.props.input)}
                    onChange={this.onValueChange}
                    size={size}
                    onBlur={this.onBlur}
                    onSelect={this.onSelect}
                    onClear={this.onClear}
                    style={{width: '100%'}}
                    getPopupContainer={() => getPopupContainer ? document.getElementById(getPopupContainer) : document.getElementById('card')}
                >
                    {options && options.map((item, index) =>
                        <Option className={optionsLabelImg ? 'text-center' : null} disabled={item[optionsDisabled]} value={item[optionsValue]} key={index}>
                            {optionsLabelImg
                                ? <><img src={item[optionsLabel]} style={{borderRadius: '100%', height: 16, width: 16}}/></>
                                : <>{translate ? trb(translate + item[optionsLabel]) : item[optionsLabel]}</>
                            }
                        </Option>
                    )}
                </Select>
            </div>
            <div className={
                classNameError
                    ? 'form-field-error ' + classNameError
                    : inline ? 'form-field-error col-12 col-md-3' : 'form-field-error col-12'}>{meta.touched && (meta.error || meta.submitError)}</div>
        </div>
    }
};

